import { z } from 'zod';
import { PhotoReportParamsSchema } from './photoReportParams.js';
export const PhotoReportInputSchema = PhotoReportParamsSchema.extend({
    documentIds: z.string().array(),
});
